module.exports = __webpack_public_path__ + "static/media/iconEditAdress.4193d1b2.svg";